import React from 'react';
import {connect} from 'react-redux';
import axios from '../../../../axios-config.js';

class SceneFileEditor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			scene: '',
			jsonValid: false,
			locked: true
		};
		this.getScene = this.getScene.bind(this);
		this.saveScene = this.saveScene.bind(this);
	}

	componentDidMount () {
		this.getScene();
	}

	getScene () {
		this.setState({scene: JSON.stringify(Inventum.generateSceneJSON(), null, 2), jsonValid: true })
	}

	saveScene () {
		if (!this.state.jsonValid) return;
		if (this.state.locked) return;
		let apiURL = `/project/${this.props.projectID}/scene/update`;
		axios.post(apiURL, {name:"New Scene", data: JSON.parse(this.state.scene)})
		.then((result) => {
			Inventum.notifications.addNotification({content:"Updated Review Version", displayTime:3000});
			Inventum.scene.clearUnsaved();
		})
		.catch((error) => {
			Inventum.notifications.addNotification({content:"Something went wrong. Check the console.", displayTime:7000});
			console.log('Error Posting New Scene');
			console.log(error);
		})
	}

	render () {
		const isValidJSON = (str) => {
			if (typeof(str) !== 'string') return false;
			if (str.length === 0) return false;

			try {
				JSON.parse(str);
			} catch (e) {
				return false;
			}

			return true;
		}

		const handleChange = (e) => {
			this.setState({scene: e.target.value, jsonValid: isValidJSON(e.target.value)});
		}

		return (
			<div className="SceneEditorContent">
				<div className="SceneEditorHeader">
					<div className="SceneEditorTitle">
						<i className="material-icons notranslate">code</i>
						<span>Scene JSON Editor</span>
					</div>
					<div className="SceneEditorStatus">
						{this.state.locked ? (
							<div className="SceneStatusBadge locked">
								<i className="material-icons notranslate">lock</i>
								<span>Locked</span>
							</div>
						) : (
							<div className="SceneStatusBadge unlocked">
								<i className="material-icons notranslate">lock_open</i>
								<span>Unlocked</span>
							</div>
						)}
						{this.state.jsonValid ? (
							<div className="SceneStatusBadge valid">
								<i className="material-icons notranslate">check_circle</i>
								<span>Valid JSON</span>
							</div>
						) : (
							<div className="SceneStatusBadge invalid">
								<i className="material-icons notranslate">error</i>
								<span>Invalid JSON</span>
							</div>
						)}
					</div>
				</div>

				<div className="SceneEditorWarning">
					<i className="material-icons notranslate">warning</i>
					<div>
						<strong>Caution:</strong> This is an advanced feature. Improper modifications may break your scene.
						Always keep a backup before making changes.
					</div>
				</div>

				<div className="SceneEditorActions">
					{this.state.locked ? (
						<button 
							className="SceneEditorButton unlock"
							onClick={() => {this.setState({locked: false})}}>
							<i className="material-icons notranslate">lock_open</i>
							<span>Unlock Editor</span>
						</button>
					) : (
						<>
							<button 
								className="SceneEditorButton lock"
								onClick={() => {this.setState({locked: true})}}>
								<i className="material-icons notranslate">lock</i>
								<span>Lock Editor</span>
							</button>
							<button 
								className={`SceneEditorButton save ${!this.state.jsonValid ? 'disabled' : ''}`}
								onClick={this.saveScene}
								disabled={!this.state.jsonValid}>
								<i className="material-icons notranslate">save</i>
								<span>Save Scene</span>
							</button>
							<button 
								className="SceneEditorButton refresh"
								onClick={this.getScene}>
								<i className="material-icons notranslate">refresh</i>
								<span>Reload</span>
							</button>
						</>
					)}
				</div>

				{!this.state.jsonValid && !this.state.locked && (
					<div className="SceneEditorError">
						<i className="material-icons notranslate">error_outline</i>
						<span>Invalid JSON syntax detected. Fix errors before saving.</span>
					</div>
				)}

				<div className="SceneEditorTextareaWrapper">
					<textarea 
						readOnly={this.state.locked}
						className={`SceneEditorTextarea ${this.state.locked ? 'locked' : ''} ${!this.state.jsonValid ? 'invalid' : ''}`}
						value={this.state.scene} 
						onChange={handleChange}
						spellCheck="false"
						placeholder="Scene JSON will appear here..."
					/>
				</div>

				<div className="SceneEditorFooter">
					<div className="SceneEditorInfo">
						<i className="material-icons notranslate">info</i>
						<span>Lines: {this.state.scene.split('\n').length} | Characters: {this.state.scene.length}</span>
					</div>
				</div>
			</div>
		)
	}
}

let mapStateToProps = (state) => ({
  projectID: state.activePage.projectID
})

let mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SceneFileEditor)
